<template>
  <div
    class="overlay-side-panel"
    v-bind:class="{
      left: direction === 'left',
      right: direction === 'right',
      show: localShow,
      'in-front': isInFront,
    }"
  >
    <section class="header">
      <!--
        @slot タイトル表示部
          @bindings {string} title タイトル
      -->
      <slot name="title" v-bind:title="title">
        <h5 class="title">{{ title }}</h5>
      </slot>
      <button class="close-button" v-on:click="localShow = false">
        <icon-clear class="icon" />
      </button>
    </section>
    <!--
      @slot メインコンテンツ部
    -->
    <slot v-bind="$props"></slot>
  </div>
</template>

<script>
import IconClear from '@/assets/ifield/text-clear.svg?component'

/**
 * オーバーレイするサイドパネルコンポーネント
 * * フィットさせたい要素を包含ブロックにすること
 */
export default {
  name: 'AppOverlaySidePanel',
  components: {
    IconClear,
  },
  model: {
    prop: 'show',
    event: 'change:show',
  },
  inheritAttrs: false,
  props: {
    /**
     * 表示フラグ
     * @model
     */
    show: {
      type: Boolean,
      default: false,
    },
    /**
     * 出現方向
     * @values left, right
     */
    direction: {
      type: String,
      default: 'right',
    },
    /**
     * タイトル
     */
    title: {
      type: String,
      default: '',
    },
  },
  emits: [
    /**
     * 表示状態変更イベント
     * @param {boolean} show 表示状態
     */
    'change:show',
  ],
  data: function () {
    return {
      /**
       * 表示状態(ローカル保持用)
       */
      localShow: false,
      /**
       * 前面表示フラグ
       */
      isInFront: false,
      /**
       * 自身の幅(px)
       */
      width: null,
    }
  },
  computed: {
    /**
     * 非表示時のオフセット値
     * @type {string}
     */
    offset() {
      if (!this.width) return '-100%'
      return `-${this.width}px`
    },
  },
  watch: {
    show: {
      immediate: true,
      handler: function (value) {
        this.localShow = !!value
      },
    },
    localShow: function (value) {
      this.$emit('change:show', value)
      if (value) {
        // false => true 時は transition 見せるために即時に前面に出す
        this.isInFront = true
      } else {
        // true => false 時は transition の終了を待ってから背面に隠す
        setTimeout(() => {
          this.isInFront = false
        }, 500)
      }
    },
  },
  mounted: function () {
    this.observer = new ResizeObserver(this.updateWidth)
    this.observer.observe(this.$el)
  },
  beforeDestroy: function () {
    this.observer.disconnect()
  },
  methods: {
    /**
     * 幅を更新する
     */
    updateWidth() {
      const rect = this.$el.getBoundingClientRect()
      this.width = rect.width
    },
  },
}
</script>

<style lang="scss" scoped>
.overlay-side-panel {
  width: max-content;
  height: 100%;
  padding: 16px;
  color: $text-color;
  background-color: #ffffff;
  border: 1px solid #ebebeb;
  display: grid;
  grid-template-rows: max-content 1fr max-content;
  z-index: -1;
  position: absolute;
  top: 0;
  transition:
    left 0.5s,
    right 0.5s;

  &.in-front {
    z-index: 100;
  }

  &.right {
    right: v-bind(offset);

    &.show {
      right: 0;
    }
  }

  &.left {
    left: v-bind(offset);

    &.show {
      left: 0;
    }
  }
}

.header {
  width: 100%;
  margin: 8px 0 16px 0;
  padding: 0 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 32px;

  .title {
    font-size: $font-size-large;
    font-weight: $font-weight-bold;
    line-height: 1;
    margin: 0;
  }

  .close-button {
    flex-shrink: 0;
    height: 24px;
    width: 24px;
    background: none;
    border: none;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .icon {
      flex-shrink: 0;
      height: 24px;
      width: 24px;
      fill: $text-color;

      &:hover {
        opacity: 0.5;
      }
    }
  }
}
</style>
